import React, { useEffect, useState } from "react"
import Verfied from "../../components/Lystface/Helper/Verification/Verified/Verfied"
import SupportLayoutHelper from "../../components/Lystface/Common/SupportLayoutHelper"
import BackgroundHelper from "../../components/Lystface/Common/BackgroundHelper"

import Verfiedlogo from "../../assets/images/lystfacelogos/verified.svg"
import withRouter from "../../components/Common/withRouter"
import Loading from "../../components/Common/Loading"
import { LystfaceVerifyUser } from "../../helpers/lystface_helper"
import { appConstants } from "../../constants/app_constants"
import linkbrokenlogo from "../../assets/images/lystfacelogos/linkbroken.svg"
import { createSelector } from "reselect"
import { useDispatch, useSelector } from "react-redux"
import { CustomToast } from "../../components/Lystface/Common/CustomToast"
import { resetRegisterResponseMsg } from "../../store/actions"
import VerifylinkResendLayout from "../../components/Lystface/Helper/Verification/VerifylinkResendLayout"
import BackgroundAuthentication from "../../components/Lystface/Common/BackgroundAuthentication"


const VerfiedPage = props => {
  document.title = `Verified | ${appConstants.cName}`

  const [isLoading, setIsLoading] = useState(true)
  const [errorStatus, setErrorStatus] = useState({ error: false, message: null })
  const dispatch = useDispatch()
  const RegisterUserState = state => state.Account
  const RegisterUserProperties = createSelector(
    RegisterUserState,
    RegisterUser => ({
      loading: RegisterUser.loading,
      registrationErrorMessage: RegisterUser.registrationErrorMessage,
      registrationError: RegisterUser.registrationError,
      user: RegisterUser.user,
    })
  )
  const {
    loading,
    registrationErrorMessage,
    registrationError,
    user,
  } = useSelector(RegisterUserProperties)

  useEffect(() => {
    if (registrationErrorMessage !== null) {
      CustomToast({
        message: registrationErrorMessage,
        status: registrationError ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      dispatch(resetRegisterResponseMsg())
    }
  }, [registrationError, registrationErrorMessage])

  const redirectToLogin = () => {
    props.router.navigate("/login")
  }
  useEffect(() => {
    const VerifyId = props.router.params.emailId

    const VerifyUser = async () => {
      try {
        const Verfied = await LystfaceVerifyUser(VerifyId)
        if (Verfied.responseCode) {
          setIsLoading(false)
          setTimeout(() => {
            redirectToLogin()
          }, 5000);
        } else {
          setErrorStatus({ error: true, message: Verfied?.responseMessage, email: Verfied?.response?.email })
          setIsLoading(false)
        }
      } catch (error) {
        setErrorStatus({ error: true, message: Verfied?.responseMessage })
        setIsLoading(false)
      }
    }
    // VerifyUser()
  }, [])

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        errorStatus?.error ?
          <VerifylinkResendLayout email={errorStatus?.email} loading={loading} logo={linkbrokenlogo} title={"Error verifying email"} message={errorStatus?.message} />
          :
          <BackgroundAuthentication Image={true} form={<SupportLayoutHelper
            imgsrc={Verfiedlogo}
            title={"Email verified successfully!"}
            layout={<Verfied />}
            from="verify-email"
          />} />

      )}
    </>
  )
}

export default withRouter(VerfiedPage)
